import { useState, useMemo, useCallback, useEffect, useContext } from "react";
import {
    Box,
    Stack,
    Typography,
    Card,
    Grid,
    CardContent,
} from "@mui/material";
import { useGridApiRef, getGridStringOperators } from "@mui/x-data-grid";

import NodataImg from "../../assets/images/noData.png";
import { useDispatch, useSelector } from "react-redux";
import { UserRetentionByModuleApi } from "../../store/analytics/userRetentionByModule";
import { ThemeContext } from '../../context/ThemeContext';



import BackdropUI from "../../ui/Backdrop";
import DataGridComponent from "../../components/DataGridComponent";
import Appbar from "../../components/Appbar";
import DrawerComponent from "../../components/Drawer";
import Body from "../../components/Body";
import { useParams, useNavigate, useLocation } from "react-router-dom";



const userRetentionColumns = [
    {
        field: "id",
        headerName: "ID",
        flex: 1,
        disableColumnMenu: true,
        filterable: false,
        sortable: false,
        disableColumnMenu: true,
    },
    {
        field: "fullname",
        headerName: "Full Name",
        flex: 1,
        disableColumnMenu: true,
        filterable: false,
        filterOperators: getGridStringOperators().filter(
            (operator) => operator.value === "equals" || operator.value === "contains"
        ),
        sortable: false,
        disableColumnMenu: true,
    },
    {
        field: "username",
        headerName: "Username",
        flex: 1,
        disableColumnMenu: true,
        filterable: false,
        filterOperators: getGridStringOperators().filter(
            (operator) => operator.value === "equals" || operator.value === "contains"
        ),
        sortable: false,
        disableColumnMenu: true,
    },

];


export default function UserRetentionByModule({ region, state, module, isMaskingEnabled }) {

    const apiRef = useGridApiRef();
    const dispatch = useDispatch();
    const params = useParams();
    const navigate = useNavigate();
    const historyLocation = useLocation();
    const [isDownload, setIsDownload] = useState(false)
    const userRetentionByModule = useSelector((state) => state?.userRetentionByModule);
    const { result: tableResult, loading: tableLoading, total } = userRetentionByModule;
    const [queryOptions, setQueryOptions] = useState({});
    const { paginationModel, setPaginationModel } = useContext(ThemeContext)

    const onFilterChange = useCallback((filterModel) => {
        setQueryOptions({ filterModel: { ...filterModel } });
    }, []);
    // const toggleTeacherRegistration = useCallback((key) => {
    //     setTeacherRegistration(prevState => ({ ...prevState, [key]: !prevState[key] }));
    // }, []);
    // const toggleActiveVsAvgTimeSpent = useCallback((key) => {
    //     setActiveVsAvgTimeSpent(prevState => ({ ...prevState, [key]: !prevState[key] }));
    // }, []);
    const getRowSpacing = useCallback((params) => {
        return {
            top: params.isFirstVisible ? 0 : 5,
            bottom: params.isLastVisible ? 0 : 5,
        };
    }, []);
    const handleSortModelChange = useCallback((sortModel) => {
        setQueryOptions({ sortModel: [...sortModel] });
    }, []);

    useEffect(() => {
        // console.log("isMaskingEnabled",isMaskingEnabled);
        const filterModel = queryOptions?.filterModel;
        const items = filterModel?.items;
        const firstItem = items && items.length > 0 ? items[0] : {};
        const quickFilterValues = filterModel?.quickFilterValues;
        const sortModel = queryOptions?.sortModel;
        let query
        if (sortModel?.length > 0) {
            query = {
                module: params?.module,
                bucket: params?.time,
                page: paginationModel?.page + 1,
                page_size: paginationModel?.pageSize,
                sort_order: sortModel[0].sort || "desc",
                field: firstItem.field || '',
                operator: firstItem.operator || (quickFilterValues && "contains") || '',
                value: firstItem.value || (quickFilterValues && quickFilterValues.toString().replaceAll(",", " ")) || ''
            };
        } else {
            query = {
                module: params?.module,
                bucket: params?.time,
                page: paginationModel?.page + 1,
                page_size: paginationModel?.pageSize,
                field: firstItem.field || '',
                sort_order: "desc",
                ...(params?.startDate && params?.startDate !== "undefined" && { start_date: params?.startDate }),
                ...(params?.endDate && params?.endDate !== "undefined" && { end_date: params?.endDate }),
                operator: firstItem.operator || (quickFilterValues && "contains") || '',
                value: firstItem.value || (quickFilterValues && quickFilterValues.toString().replaceAll(",", " ")) || ''
            };
        }
        dispatch(UserRetentionByModuleApi(query));
    }, [dispatch, queryOptions, paginationModel, region, state, module, params?.startDate, params?.endDate, isMaskingEnabled]);

    useEffect(() => {

        sessionStorage.setItem('analyticsTabIndex', '9');
        window.history.pushState({ tabIndex: 9 }, '');

        const handlePopState = (event) => {
            navigate('/get-analytics', {
                replace: true,
                state: { tabIndex: 9 }
            });
        };

        window.addEventListener('popstate', handlePopState);

        return () => {
            window.removeEventListener('popstate', handlePopState);
        };
    }, [navigate]);

    return (
        <>
            <Appbar />
            <DrawerComponent />
            <Body>
                <Stack direction="row" spacing={1} sx={{ my: 2, padding: "10px" }} alignItems="center" justifyContent={"space-between"}>
                    <Typography variant="h3">
                        {`
                        User retention in
                        ${params?.module?.replace(/_/g, " ")
                                // ?.toLowerCase()
                                ?.replace(/^\w/, c => c.toUpperCase())
                            }
                        for 
                       ${(params && params.time || "").replace("min", " minutes").replace("hr", " hours")}
                        `}
                    </Typography>
                </Stack>
                <Stack direction="row" spacing={1} sx={{ my: 2, padding: "10px" }} alignItems="center">
                    <DataGridComponent
                        disableColumnMenu
                        disableColumnSorting
                        loading={tableLoading}
                        rowCount={total}
                        pageSize={paginationModel?.pageSize}
                        onPageSizeChange={(newPageSize) => {
                            setPaginationModel({
                                ...paginationModel,
                                pageSize: newPageSize,
                            })
                        }}
                        paginationModel={paginationModel}
                        onPaginationModelChange={setPaginationModel}
                        sx={{
                            height: 500
                        }}
                        rows={tableResult ?? []}
                        getRowId={(r) => r.id}
                        getRowSpacing={getRowSpacing}
                        columns={userRetentionColumns}
                        onSortModelChange={handleSortModelChange}
                        onFilterModelChange={onFilterChange}
                        slots={{
                            noRowsOverlay: () => (
                                <Box className="noData">
                                    <img src={NodataImg} alt="no data found" />
                                </Box>
                            ),
                            // toolbar: (props) =>
                            // (CustomGridToolbar({
                            //     ...props, moduleType: "CourseProgress", queryOptions: queryOptions, paginationModel: paginationModel, isDownload: isDownload, setIsDownload: setIsDownload, apiUrl: apiRoutes.userList,
                            //     region: region,
                            //     state: state,
                            //     startDate: startDate,
                            //     endDate: endDate
                            // })),
                        }}
                        slotProps={{
                            loadingOverlay: {
                                variant: 'linear-progress',
                                noRowsVariant: 'linear-progress',
                            },
                            toolbar: {
                                // showQuickFilter: true,
                                showQuickFilter: false,
                            },
                        }}
                    />
                </Stack>
                <BackdropUI open={isDownload} />
            </Body>
        </>)
}

